<template>
  <div
    class="sample-details-card sample-not-reviewed is-clickable"
    role="button"
    tabindex="0"
    @click="navigateToSampleType"
    @keydown.enter.prevent="navigateToSampleType"
    @keydown.space.prevent="navigateToSampleType"
  >
    <div class="icon-not_reviewed">
      <img :src="inReviewIconSvg" alt="review icon" />
    </div>
    <div class="sample-not-reviewed-content">
      <h4>{{ getSampleValue }}</h4>
      <p>
        {{ $t('lastSamples.notReviewed') }}
      </p>
    </div>
    <span class="sample-card-arrow f7-icons" aria-hidden="true">
      chevron_right
    </span>
  </div>
</template>

<script>
import inReviewIconSvg from '@/static/icons/sin_revisar.svg';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'ReviewsCard',
  props: {
    sampleType: { type: Object, required: true },
    firstSampleTypeKey: { type: String, required: true },
  },
  data() {
    return {
      sampleTypesRouteMap: {
        Agronomía: 'AgronomySamplesPage',
        Alimentaria: 'FoodSamplesPage',
        'Medio Ambiente': 'EnvironmentSamplesPage',
        Minería: 'MiningSamplesPage',
        'Salud y Seguridad': 'HealthAndSecuritySamplesPage',
      },
    };
  },
  computed: {
    inReviewIconSvg: () => inReviewIconSvg,
    getSampleValue() {
      return this.firstSampleTypeKey
        ? this.sampleType[this.firstSampleTypeKey]?.pending_review ||
            0
        : 0;
    },
  },
  methods: {
    navigateToSampleType() {
      try {
        // 🔥 SOLO navegar con el query parameter
        // El filtrado lo maneja el componente de destino
        this.$f7router.navigate({
          name:
            this.sampleTypesRouteMap[this.firstSampleTypeKey] ??
            'DashboardHome',
          query: { dashboardNotReviewed: 'true' },
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
  },
};
</script>

<style lang="scss">
.generic-sample-card {
  .sample-details-card.sample-not-reviewed {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 6px;
      background: rgba(62, 60, 68, 0.38);
    }

    .icon-not_reviewed {
      width: 34px;
      height: 34px;
      flex-shrink: 0;
      background-color: var(--Neutral-20, #e5e4e7);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 19px;
        height: 19px;
        flex-shrink: 0;
      }
    }

    .sample-not-reviewed-content {
      display: flex;
      flex: 1;
      min-width: 0;
      align-items: center;
      gap: 8px;

      h4 {
        color: var(--Neutral-70, #3e3c44);
        font-size: 21px;
        font-style: normal;
        font-weight: 700;
        line-height: 1;
        padding-bottom: 2px;
        letter-spacing: -0.02em;
        margin: 0;
      }

      p {
        color: var(--Neutral-70, #3e3c44);
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5;
        text-decoration: none;
        margin: 0;
        white-space: nowrap;
      }
    }
  }
}
</style>
